import { BrowserRouter } from "react-router-dom"

import AppProvider from "../hooks"
import RoutesApplication from "./Routes"

const Routes = () => (
  <BrowserRouter>
    <AppProvider>
      <RoutesApplication />
    </AppProvider>
  </BrowserRouter>
)

export default Routes
